import React, { useMemo, FC } from 'react';
import { clampMonth, isDisabledMonth, shiftDate } from './utils';
import { MonthToggleProps, DATE_PART } from './DatePickerTypes';

const getAriaLabel = (months: string[], month: number, year: number, inc: number) => {
  const monthLabel = months[clampMonth(month, inc)];
  let yearLabel;
  if (month === 0 && inc === -1) {
    yearLabel = year - 1;
  } else if (month === months.length - 1 && inc === 1) {
    yearLabel = year + 1;
  } else {
    yearLabel = year;
  }
  return `${monthLabel} ${yearLabel}`;
};

export const MonthToggle: FC<MonthToggleProps> = ({
  inc,
  disabledDays = {},
  months,
  focusedDate,
  shift,
  labels,
  id
}) => {
  const { before, after } = disabledDays;
  const { month, year } = focusedDate;

  const monthTitle = useMemo(() => {
    if (inc === -1) {
      return labels.prevMonth;
    }
    if (inc === 1) {
      return labels.nextMonth;
    }
    return '';
  }, [labels, inc]);

  const disabled = isDisabledMonth(shiftDate(focusedDate, inc, DATE_PART.MONTH, false), before, after, inc);
  return (
    <button
      type="button"
      aria-label={getAriaLabel(months, month, year, inc)}
      onClick={() => !disabled && shift(inc, DATE_PART.MONTH, true, true)}
      disabled={disabled}
      data-testid={id}
      id={id}
      className="month-toggle">
      <span className="sr-only">{monthTitle}</span>
      <span
        className={`${disabled ? 'disabled' : ''} ${inc === 1 ? 'arrow-right' : 'arrow-left'}`}
        aria-hidden="true"
      />
    </button>
  );
};

MonthToggle.displayName = 'MonthToggle';
export default MonthToggle;
